// components/RedirectHandler.tsx
import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {fallbackUrls} from "../api/fallback-urls";


const redirects: Record<string, string> = fallbackUrls;

const RedirectHandler: React.FC = () => {
    const location = useLocation();

    if (redirects[location.pathname]) {
        const redirectTo = redirects[location.pathname];

        return (
            <HelmetProvider>
                <Helmet>
                    <meta name="prerender-status-code" content="301"/>
                    <meta name="prerender-header" content={`Location: https://baon.ru${redirectTo}`}/>
                </Helmet>
                <Navigate to={redirectTo} replace />
            </HelmetProvider>
        );
    }

    return null;
};

export default RedirectHandler;